


























import Vue from 'vue';

export default Vue.extend({
  name: 'num-input',
  props: {
    value: {
      type: Number,
      default: 1,
    },
    label: String,
  },
});
